<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-04-27 09:36:05
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-31 09:15:43
-->
<template>
  <div>
    <videoDom v-if="language == 'zh'" />
    <Banner />
    <Introduction />
    <Hexinchanping />
    <News v-if="language == 'zh'"/>
    <Partner />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import videoDom from './components/video' // 视频播放
import Banner from './components/banner' // 首页轮播
import Introduction from './components/introduction' // 脉流简介
import Hexinchanping from './components/hexinchanping' // 核心产品
import News from './components/news' // 核心产品
import Partner from './components/partner' // 核心产品

export default {
  name: 'Index',
  components: {
    videoDom,
    Banner,
    Introduction,
    Hexinchanping,
    News,
    Partner
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
</style>
